import React, { useState } from 'react';
import { toast } from 'sonner';
import smsService from '../../services/smsService';
import { X, Phone, CheckCircle, HourglassMedium, Envelope } from '@phosphor-icons/react';
import './FeeReminderSMSModal.css';

function FeeReminderSMSModal({ isOpen, onClose, student, amount, dueDate, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  if (!isOpen || !student) return null;

  const handleSend = async () => {
    setLoading(true);
    try {
      const response = await smsService.sendFeeReminder({
        student_id: student.id,
        amount_due: parseFloat(amount),
        due_date: dueDate
      });

      if (response.success) {
        toast.success(`SMS sent to ${student.parent_name}!`);
        setConfirmed(true);
        setTimeout(() => {
          onClose();
          if (onSuccess) onSuccess();
          setConfirmed(false);
        }, 2000);
      }
    } catch (err) {
      toast.error('Failed to send SMS: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const messageSample = `${student.first_name} owes ${amount} (due ${dueDate}). Please pay. -School`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal fee-sms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <Phone size={24} />
            Send Fee Reminder SMS
          </h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        {confirmed ? (
          <div className="modal-body success-state">
            <div className="success-icon"><CheckCircle size={24} /></div>
            <h3>SMS Sent Successfully!</h3>
            <p>Fee reminder sent to {student.parent_name}</p>
          </div>
        ) : (
          <>
            <div className="modal-body">
              {/* Student Info */}
              <div className="info-section">
                <h3>Student Information</h3>
                <div className="info-row">
                  <span className="info-label">Student:</span>
                  <span className="info-value">{student.first_name} {student.last_name}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Parent Name:</span>
                  <span className="info-value">{student.parent_name}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Parent Phone:</span>
                  <span className="info-value phone">{student.parent_phone || 'Not available'}</span>
                </div>
              </div>

              {/* Fee Details */}
              <div className="info-section">
                <h3>Fee Details</h3>
                <div className="info-row">
                  <span className="info-label">Amount Due:</span>
                  <span className="info-value amount">GHS {parseFloat(amount).toLocaleString()}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Due Date:</span>
                  <span className="info-value">{dueDate}</span>
                </div>
              </div>

              {/* Message Preview */}
              <div className="message-section">
                <h3><Envelope size={18} /> SMS Message Preview</h3>
                <div className="message-box">
                  <p>{messageSample}</p>
                </div>
                <p className="message-hint">This is how the SMS will appear to the parent</p>
              </div>
            </div>

            <div className="modal-footer">
              <button
                onClick={onClose}
                className="btn btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleSend}
                className="btn btn-primary"
                disabled={loading || !student.parent_phone}
              >
                {loading ? (<><HourglassMedium size={18} /> Sending...</>) : (<><CheckCircle size={18} /> Send SMS</>)}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default FeeReminderSMSModal;
